// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/pricing/pricing.scss
 ** module id = 104
 ** module chunks = 0 1
 **/